const firebaseConfigMatmissionen = {
  apiKey: "AIzaSyD9tHy9nYf29ezvNwtU0lgLs3dxl8rfGuk",
  authDomain: "matmissionen-bb65b.firebaseapp.com",
  projectId: "matmissionen-bb65b",
  storageBucket: "matmissionen-bb65b.appspot.com",
  messagingSenderId: "476299882535",
  appId: "1:476299882535:web:43ebf960bf2dccc7d19e02",
  measurementId: "G-LLZDJHH5Z4"
};

const firebaseConfigMatratt = {
  apiKey: "AIzaSyAk-uw4A20WMZSQdGf9_ZBnn-BZkg0SUEU",
  authDomain: "matratt-c7c0e.firebaseapp.com",
  databaseURL: "https://matratt-c7c0e.firebaseio.com",
  projectId: "matratt-c7c0e",
  storageBucket: "matratt-c7c0e.appspot.com",
  messagingSenderId: "819791999172",
  appId: "1:819791999172:web:d2f62d501510e831fb5991",
  measurementId: "G-4V9TS9WEYW"
};

export const getFirebaseConfig = () => {
  return (
    process.env.REACT_APP_BUILD_TARGET === 'Matmissionen' ? firebaseConfigMatmissionen
    : process.env.REACT_APP_BUILD_TARGET === 'Maträtt' ? firebaseConfigMatratt
    : null
  );
};